// Who may enter a workspace -- pure, so it is testable with node
// (espaciosLogica.test.mjs); espacios.js re-exports it.

// Who sees Comercial: whoever holds some Comercial function (comercial_funciones
// in /auth/me; Comercial > Administración > Permisos decides), never a role.
export const entraAComercial = (user) => (user?.comercial_funciones || []).length > 0
export const tieneFuncionComercial = (user, funcion) => (user?.comercial_funciones || []).includes(funcion)

// May the user enter this workspace definition ({roles} or {entra})?
export function puedeEntrar(e, user, roles = user?.roles || []) {
  if (!e) return false
  return e.entra ? e.entra(user, roles) : (e.roles || []).some(r => roles.includes(r))
}
